import { render, staticRenderFns } from "./list.vue?vue&type=template&id=77822652&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77822652",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77822652')) {
      api.createRecord('77822652', component.options)
    } else {
      api.reload('77822652', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=77822652&scoped=true&", function () {
      api.rerender('77822652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/devicesAndApps/list.vue"
export default component.exports